import React, { Component } from "react";
// import RoadmapImg from "../assets/images/footer-bg.png";
import FaqSection from "../components/Faqsection";
import Footer from "./Footer";
// import Logo from '../assets/images/jackbotslogo.png'
// import Jackport from '../assets/images/footer-bot.png'
// import { Social_3 } from "./Social";

// import Tweeter from '../assets/images/tweetor.png'
// import Instagram from '../assets/images/instagram.png'
// import Discord from '../assets/images/discord.png'
// import faqbg from "../images/faqbg.png"



export default class FAQ extends Component {
    render() {
        return (
            <div
                id="faq"
                className="BGImageSize pb-4"
                style={{
                    // backgroundImage: `url(${RoadmapImg})`,
                    backgroundSize: 'cover',
                    backgroundRepeat: "no-repeat",
                    position: "relative"
                }}
            >
                <div className="container-fluid borderBottom px-sm-10">
                    <h2 className="text-center text-white roadmapheading text-uppercase pt-5 pb-5">Frequently Asked Questions</h2>
                    <div className="">
                        {/* <img className="" src={faqbg}></img> */}
                        <div className="faqbg">
                            <FaqSection
                                index={1}
                                question="What are #######?"
                                answere={<span>####### NFTs are unique #### Tokens created on the ############# that grant you
                                    access to multi-utility benefits such as ######</span>} />
                            <FaqSection
                                index={2}
                                question="When Can I Buy ######?"
                                answere={<span>Presale - ####### <br />Public Sale - ####</span>} />
                            <FaqSection
                                index={3}
                                question="What Is The Price Of A #####?"
                                answere={<span>Presale - ######
                                    <br />Public Sale - ######</span>} />
                            <FaqSection
                                index={4}
                                question="Where Can I Buy/Mint My Own?"
                                answere={<span>Minitng takes place directly on our website. Please connect your wallet to mint</span>} />
                            <FaqSection
                                index={5}
                                question="How Many Can I Buy?"
                                answere={<span>Our goal is to grow an exclusive community while also maintaining a healthy community of
                                    ###### holders therefore the most one can mint is 4 ####.</span>} />
                            {/* <FaqSection
                            index={6}
                            question="How Many JackBots Will Be Minted?"
                            answere={<span>3,333 Total<br />
                                3,000 On Public sale<br />
                                333 Will be rewarded as giveaways</span>} />
                        <FaqSection
                            index={7}
                            question="Have Another Question?"
                            answere={<span>Please email us at <br /> info@jackbotsnft.com</span>} /> */}
                        </div>
                    </div>
                   
                </div>
              
            </div>
        );
    }
}
